module.exports = __webpack_public_path__ + "img/malnalila.39678aa6.webp";